import styled from "styled-components"

export const BannerStyles = styled.section`
  .gatsby-image-wrapper {
    height: 100vh;
    color: #000;
    position: relative;
  }

  .hero-content {
    position: absolute;
    color: #000;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
    text-align: left;
    height: 100%;
    width: 100%;
    max-width: 500px;
    padding: 0 18px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: auto;
    margin-right: auto;

    @media (min-width: 768px) {
      max-width: 650px;
    }

    h1 {
      font-size: 2.25rem;
      line-height: 1.2;

      span {
        @media (min-width: 768px) {
          // background: -webkit-linear-gradient(130deg, #fce201, #fc4701);
          // -webkit-background-clip: text;
          // -webkit-text-fill-color: transparent;
        }
      }
    }

    p {
      margin-top: 0;
      margin-bottom: 2rem;
      line-height: 1.2;
      font-size: 1.15rem;

      @media (min-width: 768px) {
        font-size: 1.35rem;
      }

      @media (min-width: 1200px) {
        font-size: 1.5rem;
      }
    }

    button,
    .anchor {
      margin: 0 auto;
    }

    @media (min-width: 768px) {
      max-width: 800px;

      h1 {
        font-size: 3rem;
      }
    }

    @media (min-width: 1200px) {
      h1 {
        font-size: 4rem;
      }
    }
  }
`
